const swDev = () => {
  const determineAppServerKey = () => {
    const vapidPublicKey =
      "BA3RnQbohhPHLuWBKsMcbK8LE4AzjNn1-KVgcbhfFkX-QOoyZPQ-4jqD06nnDK1PmS-04TYE2blnDv1aaBzcsYo";
    return urlBase64ToUint8Array(vapidPublicKey);
  };

  const urlBase64ToUint8Array = (base64String: string) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  let swUrl = `${process.env.PUBLIC_URL}/sw.js`;

  // eslint-disable-next-line no-restricted-globals
  if (location.pathname.includes(`${process.env.PUBLIC_URL}/recruit/`)) {
    navigator.serviceWorker
      .register(swUrl, { scope: "/" })
      .then((res) => {
        return res.pushManager.getSubscription().then(async (sub) => {
          let subscription = await res.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: determineAppServerKey(),
          });

          return subscription;
        });
      })
      .catch((err) => {
        console.error("error", err);
      });
  }
};

export default swDev;
